import axios, { AxiosError } from "axios";

export const handleAxiosError = (error: unknown): string => {
    if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<{
            message?: string;
            error?: string;
        }>;

        // Jika server memberikan response error (status code di luar 2xx)
        if (axiosError.response) {
            return (
                axiosError.response.data?.message ||
                axiosError.response.data?.error ||
                axiosError.message
            );
        }

        // Jika request berhasil dikirim tapi tidak ada response dari server (misal server down atau koneksi terputus)
        if (axiosError.request) {
            return "Tidak dapat terhubung ke server. Periksa koneksi internet Anda.";
        }

        // Error lain yang terjadi saat setup request
        return axiosError.message;
    }

    // Jika error berasal dari hal lain selain axios (contoh: error javascript biasa)
    if (error instanceof Error) {
        return error.message;
    }

    return "Terjadi kesalahan yang tidak diketahui.";
};
